import React from "react";
import { LOCALES } from "../../i18n/locale";
import { useLocale } from "../../context/LocaleContext";

const LocaleSwitcher = () => {
  const { locale, setLocale, t } = useLocale();

  return (
    <div className="locale-switcher" role="group" aria-label={t("Jezik")}>
      {LOCALES.map((option) => (
        <button
          key={option.id}
          type="button"
          className={`locale-switcher-btn${locale === option.id ? " active" : ""}`}
          onClick={() => setLocale(option.id)}
          title={t(option.name)}
          aria-pressed={locale === option.id}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default LocaleSwitcher;
